import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import * as styles from './Image-slider.module.scss';

const ImageSlider = ({ heading, imagesArray }) => {
  const duplicatedImages = [...imagesArray, ...imagesArray];

  return (
    <section className={`container bg-white c-padding ${styles.OurClients}`}>
      {heading &&
        <h2 className={`global-spacing-bottom`}>{heading.heading}</h2>
      }
      <div className={styles.desktopGrid}>
        {imagesArray.map((logo, index) => (
          <div key={index} className={styles.gridItem}>
            <GatsbyImage
              image={logo.gatsbyImageData}
              alt={logo.title || `Client Logo ${index + 1}`}
              className={styles.logo}
            />
          </div>
        ))}
      </div>
      <div className={styles.mobileScroller}>
        <div className={styles.scrollerTrack}>
          {duplicatedImages.map((logo, index) => (
            <div key={index} className={styles.gridItem}>
              <GatsbyImage
                image={logo.gatsbyImageData}
                alt={logo.title || `Client Logo ${index + 1}`}
                className={styles.logo}

              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageSlider;
